// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__U8DGu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__37Ki1"};